/** Mirrors `toCamelCase` in apps/back/src/api/helpers/companyFeatureFlags.js */
export const toCamelCase = str => {
  if (typeof str !== 'string' || !str) {
    return str;
  }
  const fromKebab = str.replace(/-([a-zA-Z])/g, (_, letter) => letter.toUpperCase());
  return fromKebab.charAt(0).toLowerCase() + fromKebab.slice(1);
};

/**
 * Deduped camelCase feature-flag list (defense in depth if API returns legacy casing).
 * @param {string[] | undefined} featureFlags
 * @returns {string[]}
 */
export const normalizeFeatureFlags = (featureFlags = []) => {
  if (!Array.isArray(featureFlags)) {
    return [];
  }
  const seen = new Set();
  const out = [];
  for (const name of featureFlags) {
    const canonical = toCamelCase(name);
    if (typeof canonical === 'string' && canonical && !seen.has(canonical)) {
      seen.add(canonical);
      out.push(canonical);
    }
  }
  return out;
};

/**
 * Whether a camelCase toggle name is enabled for the company.
 * Stored flag names may be kebab-case, camelCase, or legacy PascalCase (e.g. Documents).
 */
export const hasCompanyFeature = (featureFlags, name) => {
  if (!Array.isArray(featureFlags) || !name) {
    return false;
  }
  const want = toCamelCase(name);
  return featureFlags.some(flag => toCamelCase(flag) === want);
};
